import { WatchList } from '../../../models/WatchList';
import { WatchListDto } from '../../../services/dtos/watchLists/watchList.dto';

export const mapWatchListsDtoToWatchLists = (watchlists: WatchListDto[]): WatchList[] =>
  watchlists.map((watchList) => ({
    id: watchList.id,
    tags: watchList.tags,
    createdAt: watchList.createdAt,
    name: watchList.name,
    updatedAt: watchList.updatedAt,
    myCS: watchList.myCS,
    mode: watchList.mode,
  }));

export const mapWatchlistDtoToWatchlist = (watchlist: WatchListDto): WatchList => ({
  id: watchlist.id,
  tags: watchlist.tags,
  createdAt: watchlist.createdAt,
  name: watchlist.name,
  updatedAt: watchlist.updatedAt,
  myCS: watchlist.myCS,
  mode: watchlist.mode,
});
